/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Entity_Sales_OrdersInputs */



/**
* | output |
* | --- |
* | "Sales orders" |
*
* @param {Agent_Event_Entity_Sales_OrdersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_entity_sales_orders = /** @type {((inputs?: Agent_Event_Entity_Sales_OrdersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Entity_Sales_OrdersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verkaufsaufträge")
	return /** @type {LocalizedString} */ ("Sales orders")
});